import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const prescriptionsApi = {
  async list(params = {}) {
    const response = await apiClient.get("/prescriptions", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async updateStatus(id, status) {
    const response = await apiClient.patch(`/prescriptions/${id}/status`, { status });
    return unwrapEnvelope(response.data, null);
  },

  async finalize(id, payload = {}) {
    const response = await apiClient.post(`/prescriptions/${id}/finalize`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async amend(id, payload = {}) {
    const response = await apiClient.post(`/prescriptions/${id}/amend`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async generateInvoice(id) {
    const response = await apiClient.post(`/prescriptions/${id}/generate-invoice`, {});
    return unwrapEnvelope(response.data, null);
  },

  async verify(id, payload = {}) {
    const response = await apiClient.post(`/prescriptions/${id}/verify`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async dispense(id, payload = {}) {
    console.log("Sending request to dispense prescription", id, "with payload", payload);
    const response = await apiClient.post(`/prescriptions/${id}/dispense`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async reject(id, payload = {}) {
    const response = await apiClient.post(`/prescriptions/${id}/reject`, payload);
    return unwrapEnvelope(response.data, null);
  }
};
